import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'mpp-confirm-deletion',
  templateUrl: './confirm-deletion.component.html',
  styleUrls: ['./confirm-deletion.component.scss'],
  standalone: false,
})
export class ConfirmDeletionComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmDeletionComponent>) {}

  openPermanentlyDelete(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
